import { render, staticRenderFns } from "./MorePrint.vue?vue&type=template&id=60e238e0&"
import script from "./MorePrint.vue?vue&type=script&lang=js&"
export * from "./MorePrint.vue?vue&type=script&lang=js&"
import style0 from "./MorePrint.vue?vue&type=style&index=0&id=60e238e0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports